module.exports = __webpack_public_path__ + "static/media/send.4e1e56a0.svg";